import React from 'react';
import { get } from 'lodash';
import styles from './DMActionsInfo.module.css';

const DMActionsInfo = ({ latestActiveAction }) => {
  const isActive = ['Running', 'Pending'].includes(latestActiveAction?.runtimeStatus);
  let actionStatusString = 'None Active';
  if (isActive) {
    const actionName = get(latestActiveAction, 'input.method', get(latestActiveAction, 'name'));
    const runtimeStatus = get(latestActiveAction, 'runtimeStatus');
    actionStatusString = `${actionName} - ${runtimeStatus}`;
  }
  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={styles.header}>Device Commands</div>
        <div className={styles.body}>{actionStatusString}</div>
      </div>
    </div>
  );
};

export default DMActionsInfo;
